import { createSelector } from 'reselect';
import get from 'lodash/get';
import { toSelectOption, toSelectOptions } from '~/src/helpers/form';

const defaultArray = [];
const defaultObj = {};
const getCities = ({ city }) => get(city, 'citiesList', defaultArray);
export const getCurrentCity = ({ city }) => get(city, 'currentCity', defaultObj);

export const citiesListForHeader = createSelector(
    [getCities],
    cities => cities.map(city => ({
        cityId: city.city_id,
        domain: city.domain,
        name: city.name,
        phone: city.phone_code === '0' ? city.sale_phone : `+7 (${city.phone_code}) ${city.sale_phone}`,
        callCenter: city.call_center_phone.length > 10 ? city.call_center_phone : `+7 (${city.phone_code}) ${city.call_center_phone}`,
        billingHost: city.billing_host,
        cityIn: city.pred_name,
        prefixAgreement: city.prefix_agreement
    }))
);

const getOptionsKey = (_, key) => key;

export const selectCurrentCityOptions = createSelector(
    [getCurrentCity, getOptionsKey],
    (object, keys) => toSelectOption({ object, ...keys })
);

export const selectCitiesOptions = createSelector(
    [getCities, getOptionsKey],
    (array, keys) => toSelectOptions({ array, keys })
);

export function selectCurrentCity(state) {
    return state?.city?.currentCity?.domain;
}
